import React, { useEffect, useState } from "react";
// ✅ Correct import with actual file name
import logo from "../assets/logo1.jpeg";

const Loader = () => {
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Fast loading simulation - 0.2 seconds
    const timer = setTimeout(() => {
      setLoading(false);
    }, 200);

    // Progress animation
    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(progressInterval);
          return 100;
        }
        return prev + 50; // faster progress
      });
    }, 50);

    return () => {
      clearTimeout(timer);
      clearInterval(progressInterval);
    };
  }, []);

  if (!loading) return null;

  return (
    <div className="fixed inset-0 bg-gradient-to-br from-white via-blue-50 to-white z-[9999] flex items-center justify-center overflow-hidden">
      {/* Animated Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-400 via-blue-500 to-blue-700 animate-pulse"></div>
        <div className="absolute top-0 left-0 w-full h-full bg-grid-pattern"></div>
      </div>

      {/* Main Loader Container */}
      <div className="relative flex flex-col items-center justify-center">
        {/* Rotating Ring */}
        <div className="relative w-32 h-32 mb-4">
          <div className="absolute inset-0 border-4 border-gray-200 rounded-full animate-ping"></div>
          <div className="absolute inset-0 border-4 border-transparent border-t-blue-400 border-r-blue-500 rounded-full animate-spin"></div>
          <div className="absolute inset-2 border-4 border-transparent border-b-blue-600 border-l-blue-700 rounded-full animate-spin animation-delay-150"></div>
          
          {/* Logo Container */}
          <div className="absolute inset-0 flex items-center justify-center bg-white rounded-full shadow-2xl overflow-hidden">
            <img
              src={logo}
              alt="JTL.IN"
              className="w-20 h-20 animate-pulse filter drop-shadow-lg"
              style={{ mixBlendMode: 'multiply' }}
            />
          </div>
        </div>

        {/* JTL.IN Branding */}
        <div className="relative mb-2">
          <h1 className="text-5xl font-bold bg-gradient-to-r from-blue-500 via-blue-600 to-blue-800 bg-clip-text text-transparent animate-pulse">
            JTL.IN
          </h1>
          <div className="absolute -bottom-1 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-blue-400 to-transparent animate-pulse"></div>
        </div>

        {/* Welcome Text */}
        <p className="text-blue-700 text-xl font-bold mb-4 animate-fade-in tracking-wide uppercase">
          Welcome to Jain Trade Links
        </p>

        {/* Loading Dots */}
        <div className="flex gap-2 mb-6">
          <div className="w-3 h-3 bg-blue-400 rounded-full animate-bounce animation-delay-0"></div>
          <div className="w-3 h-3 bg-blue-500 rounded-full animate-bounce animation-delay-150"></div>
          <div className="w-3 h-3 bg-blue-600 rounded-full animate-bounce animation-delay-300"></div>
        </div>

        {/* Progress Bar */}
        <div className="w-64 h-2 bg-gray-200 rounded-full overflow-hidden mb-4">
          <div 
            className="h-full bg-gradient-to-r from-blue-400 via-blue-500 to-blue-700 rounded-full transition-all duration-200 ease-out"
            style={{ width: `${progress}%` }}
          ></div>
        </div>

        {/* Loading Text */}
        <div className="flex items-center gap-2 text-gray-600 text-sm">
          <span className="animate-pulse">Initializing</span>
          <span className="text-blue-600 font-bold">{progress}%</span>
        </div>

        {/* Floating Elements */}
        <div className="absolute top-10 left-10 w-4 h-4 bg-blue-400 rounded-full animate-float opacity-20"></div>
        <div className="absolute top-20 right-20 w-6 h-6 bg-blue-500 rounded-full animate-float animation-delay-1000 opacity-20"></div>
        <div className="absolute bottom-20 left-20 w-5 h-5 bg-blue-600 rounded-full animate-float animation-delay-2000 opacity-20"></div>
        <div className="absolute bottom-10 right-10 w-3 h-3 bg-blue-400 rounded-full animate-float animation-delay-1500 opacity-20"></div>
      </div>

      {/* Corner Decorations */}
      <div className="absolute top-0 left-0 w-20 h-20 border-t-4 border-l-4 border-blue-400 opacity-30"></div>
      <div className="absolute top-0 right-0 w-20 h-20 border-t-4 border-r-4 border-blue-500 opacity-30"></div>
      <div className="absolute bottom-0 left-0 w-20 h-20 border-b-4 border-l-4 border-blue-600 opacity-30"></div>
      <div className="absolute bottom-0 right-0 w-20 h-20 border-b-4 border-r-4 border-blue-400 opacity-30"></div>

      {/* Custom Styles */}
      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          33% { transform: translateY(-20px) rotate(120deg); }
          66% { transform: translateY(10px) rotate(240deg); }
        }
        
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
        
        .animate-fade-in {
          animation: fade-in 0.5s ease-out;
        }
        
        .animation-delay-0 { animation-delay: 0ms; }
        .animation-delay-150 { animation-delay: 150ms; }
        .animation-delay-300 { animation-delay: 300ms; }
        .animation-delay-1000 { animation-delay: 1s; }
        .animation-delay-1500 { animation-delay: 1.5s; }
        .animation-delay-2000 { animation-delay: 2s; }
        
        .bg-grid-pattern {
          background-image: 
            linear-gradient(rgba(0,0,255,.05) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0,0,255,.05) 1px, transparent 1px);
          background-size: 50px 50px;
        }
      `}</style>
    </div>
  );
};

export default Loader;